import styled from 'styled-components';
import { LabelRegularM } from '../../../../../styles/globals';
import { IThemeProvider } from '../../../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 1.2rem;
`;

export const Label = styled(LabelRegularM)<{ active?: boolean }>`
  cursor: pointer;
  user-select: none;
  ${({ theme, active }: IThemeProvider & { active?: boolean }) => `
    color: ${active ? theme.colors.secondary[100] : theme.colors.neutral.primary[60]};
    font-weight: ${active ? 700 : 400};
  `}
`;
